import type { TableCellProps } from "@mui/material";
import { TableCell } from "@mui/material";
import { makeTintedBackgroundFromColor } from "@entrilia/shared/utilities/colorHelper";

interface CellProps extends TableCellProps {
  hasError?: boolean;
}

const TransactionTableCell = ({ hasError, children, ...props }: CellProps) => {
  return (
    <TableCell
      sx={(t) => ({ bgcolor: hasError ? makeTintedBackgroundFromColor(t, t.palette.error.dark) : "inherit" })}
      {...props}
    >
      {children}
    </TableCell>
  );
};

export default TransactionTableCell;
